import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { useMessagesContext } from 'Views/Page/Content/Templates/MessagesPage/MessagesContext';
import CollectionAvatarGroup from 'Components/ComponentLibrary/Organisms/CollectionAvatarGroup';
import usePopoverState from 'Hooks/usePopoverState';
import useUserContext from 'Context/UserContext';
import { FDIcon } from '@facet-wealth/design';
import {
  ThreadParticipantListPopover,
} from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/MessagesPanel/components/MessagesPanelContent/components/ThreadHeader/components/ThreadParticipantListPopover';

const useStyles = buildUseStyles('ThreadParticipantAvatarGroup', (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    cursor: 'pointer',
    paddingRight: theme.spacing(1),
  },
  popoverRoot: {
    padding: theme.spacing(2),
    minWidth: theme.dimensions.md,
  },
}));

const ThreadParticipantAvatarGroup = ({
  className,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  const {
    selectedThreadResource,
  } = useMessagesContext();
  const { isAgent } = useUserContext();

  const {
    open,
    anchorEl,
    openPopover,
    handleClose,
  } = usePopoverState({
    onClose: async () => {
    },
  });

  // Prevent click propagation / open popover
  const toggleParticipantsPopover = event => {
    event.preventDefault();
    event.stopPropagation();
    openPopover(event);
  };

  return (
    <Box className={classNames(classes.root, className)} onClick={event => toggleParticipantsPopover(event)}>
      <CollectionAvatarGroup
        collection={selectedThreadResource.attr('threadMembers')}
      />
      { isAgent
        ? (
          <React.Fragment>
            <FDIcon icon={'visibility'} size={'sm'} color={'info'} />
            <ThreadParticipantListPopover
              handleClose={handleClose}
              open={open}
              anchorEl={anchorEl}
            />
          </React.Fragment>
        )
        : null }
    </Box>
  );
};

ThreadParticipantAvatarGroup.defaultProps = {
  className: '',
};

ThreadParticipantAvatarGroup.propTypes = {
  className: PropTypes.string,
};

export { ThreadParticipantAvatarGroup };
